import { getCookie } from 'cookies-next/client'
import { useSearchParams } from 'next/navigation'
import { type FC, useEffect, useRef } from 'react'
import { useIsomorphicLayoutEffect } from 'usehooks-ts'

import { COOKIE_AD_SERVER_USER_ID_NAME } from '../../../cookies'
import { useNextPathname } from '../../../next-pathname'
import { adServerGetCampaignCode } from '../../adServerGetCampaignCode'

import { useAdServerConfigurationContext } from './useAdServerConfigurationContext'

export const AdServerSlotsCleanup: FC = () => {
  const pathname = useNextPathname()
  const searchParams = useSearchParams()
  const cleaned = useRef<boolean>(false)

  const { adServerTargeting } = useAdServerConfigurationContext()
  const searchParamsCampaignCode = searchParams.get('campaigncode') ?? undefined

  const { context, keywords } = adServerTargeting

  /**
   * Must be a layout effect: SWR schedules its mount revalidation from a layout
   * effect too, so a passive effect here would assign `_targeting` after the
   * first recommendations request has already been built without `adServerData`.
   * `AdServerSlotsCleanup` is rendered before `children`, so within the layout
   * phase this runs first.
   */
  useIsomorphicLayoutEffect(() => {
    const campaignCodes = adServerGetCampaignCode(searchParamsCampaignCode)
    const loggedIn = Boolean(getCookie(COOKIE_AD_SERVER_USER_ID_NAME))

    globalThis._targeting = {
      context: {
        ...context,
        campaignCodes,
        loggedIn,
      },
      keywords,
    }
  }, [context, keywords, searchParamsCampaignCode])

  useEffect(() => {
    if (cleaned.current || !globalThis._slots) {
      return
    }

    globalThis._slots.length = 0
    cleaned.current = true
  }, [pathname])

  return null
}
